import type { CSSProperties } from "react";
import { siteConfig } from "../../config/site";

export function Hero() {
  return (
    <section
      className="w-full"
      style={{
        background:
          "linear-gradient(135deg, #ffffff 0%, #f2f0f6 45%, #e5e2ec 100%)",
      }}
    >
      <div className="mx-auto flex w-full max-w-[1376px] flex-col items-center gap-6 px-4 py-14 text-center sm:py-16">
        <span className="reveal reveal-1 rounded-full bg-white/60 px-5 py-2 text-xs font-semibold uppercase tracking-[0.6px] text-brand-purple">
          Loans We Provide
        </span>

        <h1 className="reveal-mask max-w-[689px]">
          <span
            className="block text-4xl font-extrabold uppercase leading-tight tracking-[0.5px] text-[#1c1917] sm:text-5xl lg:text-6xl"
            style={{ "--reveal-delay": "0.15s" } as CSSProperties}
          >
            Personal Loans
          </span>
        </h1>

        <p className="reveal reveal-3 max-w-[532px] text-base leading-7 text-[#475569] sm:text-lg">
          Simple financing for the plans, needs, and moments that matter.
        </p>

        <a
          href={siteConfig.applyLink || undefined}
          target="_blank"
          rel="noopener noreferrer"
          className="reveal reveal-4 flex items-center gap-2 rounded-full bg-[#311042] px-8 py-[14px] text-sm font-semibold text-white shadow-[0px_1px_1px_rgba(0,0,0,0.05)] transition-opacity hover:opacity-90"
        >
          Apply for loan
          <span aria-hidden="true">→</span>
        </a>
      </div>
    </section>
  );
}
